const logoUrl = process.env.REACT_APP_LOGO_URL;

export const LOGO = {
    DARK: logoUrl ? `${logoUrl}/dark.jpeg` : '',
    LIGHT: logoUrl ? `${logoUrl}/light.jpeg` : '',
    TRANSPARENT: logoUrl ? `${logoUrl}/transparent.png` : ''
};
